import { FC, ReactNode } from 'react';

import { StyleSheetManager, ThemeProvider } from 'styled-components';

import { createTeliaTheme } from './theme';

export const TeliaThemeProvider: FC<{ children?: ReactNode }> = ({ children }) => {
    return (
        <StyleSheetManager enableVendorPrefixes={true}>
            <ThemeProvider theme={createTeliaTheme()}>{children}</ThemeProvider>
        </StyleSheetManager>
    );
};
